import Footer from "../../components/Footer/Footer";
import PageHeader from "../../components/TopHeader/PageHeader";
import { Container } from "./ProfilePageStyle";
import Seo from "../../components/Seo";
import requiredAuth from "../../components/requiredAuth";
import ProfileForm from "../../components/Form/ProfileForm";

function ProfilePage() {
  return (
    <Container>
      <Seo title="내 프로필" />
      <PageHeader title="내 프로필" />
      <ProfileForm />
      <Footer />
    </Container>
  );
}

export default requiredAuth(ProfilePage);
